{
    "coordinates": [
        41.32621819098438,
        -88.37050801641138
    ],
    "tooltip": "Mazon Creek",
    "title": "Mazon Creek Fossil Beds",
    "country": "United States",
    "period": "Carboniferous",
    "alt": "TODO"
}
